import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CollectionSidebarComponent } from './collection-sidebar.component'

@NgModule({
  imports: [CommonModule],
  declarations: [CollectionSidebarComponent],
  exports: [CollectionSidebarComponent]
})
export class CollectionSidebarModule {}
